"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iOrder = exports.iOrderState = exports.iCreateOrder = exports.iOrderType = exports.iOrderFile = exports.iPrevalidateFiles = void 0;
const t = require("io-ts");
const File = require("./file");
const User = require("./user");
const billingInformation_1 = require("./billingInformation");
const distribution_1 = require("./distribution");
const _iPrevalidateFiles = t.interface({
    allowedFilesToOrder: t.array(File.iOrderFile),
    deniedItems: t.array(File.iRevisionOrFolder)
});
exports.iPrevalidateFiles = t.clean(_iPrevalidateFiles);
const _iOrderFile = t.intersection([
    File.iRevisionOrFolderSimplified,
    t.partial({
        color: t.boolean,
        excluded: t.boolean
    })
]);
exports.iOrderFile = t.clean(_iOrderFile);
const _iOrderBasic = t.intersection([
    t.interface({
        name: t.string,
        folderId: t.number,
        additionalInformation: t.string,
    }),
    t.partial({
        templateId: t.number,
        requestTimeOfDelivery: t.string,
    })
]);
const iOrderBasic = t.clean(_iOrderBasic);
exports.iOrderType = t.union([
    t.interface({ type: t.literal('ORDER') }),
    t.interface({ type: t.literal('AUTOMATIC_ORDER'), mode: t.keyof({ SAVE: null, ORDER: null }) })
]);
const _iCreateOrder = t.intersection([
    iOrderBasic,
    exports.iOrderType,
    t.interface({
        files: t.array(exports.iOrderFile),
        recipients: t.array(distribution_1.iDistributionRecipient),
        billingInformation: billingInformation_1.iBillingInformation
    }),
    t.partial({
        id: t.number,
        provided: t.boolean
    })
]);
exports.iCreateOrder = t.clean(_iCreateOrder);
exports.iOrderState = t.keyof({
    COMPLETE: null,
    DRAFT: null,
    INCOMPLETE_NO_FILES: null,
    INCOMPLETE_NO_PARTICIPANTS: null
});
// Fetched order
const _iOrder = t.intersection([
    iOrderBasic,
    t.interface({
        id: t.number,
        author: User.iAuthor,
        type: t.keyof({ ORDER: null, AUTOMATIC_ORDER: null }),
        createdAt: t.number,
        modifiedAt: t.union([t.number, t.null]),
        modifiedBy: t.union([User.iAuthor, t.null]),
        status: t.string,
        version: t.number,
        state: exports.iOrderState
    }),
    t.partial({
        orderId: t.union([t.null, t.number]),
        billingInformation: billingInformation_1.iBillingInformation
    })
]);
exports.iOrder = t.clean(_iOrder);
//# sourceMappingURL=order.js.map